module.exports = __webpack_public_path__ + "img/appImage-customer-base--preview.b35ba48e.svg";